import loadable from '@loadable/component';
import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {Text, View} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {selecetvehivletype} from 'src/selectors/Vehicle';
import Button from 'src/components/button/Button.componet';
import styles from './LearningSlider.style';
import {Shadow} from 'react-native-shadow-2';
import EmptyBox from '../../../../components/empty-box/EmptyBox.component';
import {CustomText} from '../../../../components';
import NotShowAgain from '../../components/not-show-again/ٔNotShowAgain';
import {useHistory} from '../../../../imports/Router';
import {showAlert} from '../../../../actions/AlertActions';
import {useStopwatch} from 'react-timer-hook';
const SVG = loadable(() => import('src/imports/svg'));

const Slider = ({title, image, text, end, swiperRef, id}) => {
  const {t} = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const {vehicle} = useSelector(state => selecetvehivletype(state));
  let stopwatchOffset = new Date();
  const {seconds, minutes, hours, days, reset} = useStopwatch({
    autoStart: true,
    offsetTimestamp: stopwatchOffset,
  });


  const startTrip = () => {
    history.replace('/main/map/drive');
  };

  return (
    <View style={styles.slide}>
      <EmptyBox height={68} />
      <Shadow distance={8}>
        <View style={styles.imageContainer}>
          <SVG name={image} width={168} height={152} />
        </View>
      </Shadow>
      <View style={styles.textContainer}>
        <CustomText mt={10} font={'700'} size={18}>
          {title}
        </CustomText>
        <CustomText
          txtAlign="center"
          mt={10}
          color={'#5A5A5A'}
          font={'500'}
          size={14}>
          {text}
        </CustomText>
      </View>
      <View style={styles.btncontainer}>
        {id == '3' && <NotShowAgain />}
        {end == id ? (
          <Button color={'#303261'} style={{ top : -8 }} onPress={startTrip}>
            <Text style={[styles.buttontext, {color: 'white'}]}>
              {t('map')}
            </Text>
          </Button>
        ) : (
          <></>
        )}
        <CustomText txtAlign="center">
          <CustomText size={12} font={'400'} color={'#5A5A5A'}>
            {t('trip_duration')}{' '}
          </CustomText>
          <CustomText size={12} font={'700'} color={'#161616'}>
            {`${days > 0 ? `${days}:` : ''}${
              hours > 0 ? `${hours.toString().padStart(2, '0')}:` : ''
            }${minutes.toString().padStart(2, '0')}:${seconds
              .toString()
              .padStart(2, '0')}`}
          </CustomText>
        </CustomText>
      </View>
    </View>
  );
};

export default Slider;
